
(function(window, document, $) {

	var nr = 0,

	Poll = function(_trgt)
	{
		var target = _trgt,
		poll = $(target),
		poll_id,
		poll_answers,
		poll_form,
		poll_results,
		button_vote,

		init = function() {

			poll_id = poll.data('id');
			// console.log("Poll " + poll_id);

			target.setAttribute('data-initialized', '');

			poll_answers = $('.form-check-input', poll);
			poll_form = $('.form-check', poll);
			poll_results = $('.poll-results', poll);
			button_vote = $('.btn', poll);

			poll_answers.on( "click", answer_click );
			button_vote.on( "click", vote );
		},
		answer_click = function() {

			console.log("poll_answer_click");
			button_vote.removeClass('disabled');
		},
		vote = function()
		{
			// console.log("poll vote: ", poll_id);
			var checked_answer_id = jQuery('.form-check-input:checked', poll).val();
			// console.log("checked_answer_id: " + checked_answer_id);

			var disabled = button_vote.hasClass('disabled');
			if(checked_answer_id && !disabled)
			{
				button_vote.addClass('disabled');
				send_vote(checked_answer_id);
			}
		},
		send_vote = function(answer_id)
		{
			// console.log("send_vote: " , answer_id);

			if(answer_id)
			{
				$.ajax({
					url: ajax.ajaxurl,
					type: 'post',
					data: {
						action: 'poll_set_vote',
            			poll_id: poll_id,
            			answer_id: answer_id
					},
					success: function( result ) {
						
						console.log( result );
						if(result)
						{
							show_results(result);
						}
					}
				});
			}
		},
		show_results = function(data)
		{
			data = JSON.parse( data );
			// console.log("show_results, data:", data);

			poll_form.addClass('hide');
			poll_results.removeClass('hide');

			var total_votes = 0;
			var n = data.length;
			var answers = [];
			for( var i = 0; i < n; i++ )
			{
				var votes = parseInt( data[i].answer_votes );
				total_votes += votes;
			}

			// console.log("total_votes ", total_votes);

			var results_html = '';
			for(var j = 0; j < n; j++)
			{
				var answer_text = data[j].answer_text;
				var answer_votes = data[j].answer_votes;
				var answer_percentage = ( answer_votes / total_votes ) * 100;
				var answer_percentage_rounded = Math.round(answer_percentage);
				var bar_percentage = answer_percentage_rounded;

				if(bar_percentage === 0)
				{
					bar_percentage = 0.2;
				}

				var poll_answer = '<p class="poll_result_answer">'+ answer_text + ': '+ answer_percentage_rounded +'%</div>';
				results_html += poll_answer;

				var bar = '<div class="poll_bar" style="width: '+ bar_percentage +'%;"></div>';
				results_html += bar;
			}
			poll_results.html(results_html);
		};
		init();
	};
	initializePolls = function()
	{
		// console.log("initializePolls");
		var polls = $('.middin_el_poll');

		for (var i = 0, n = polls.length; i < n; i++)
		{

			// console.log("poll " + i);
			// console.log( !polls[i].hasAttribute('data-initialized') );
			if(!polls[i].hasAttribute('data-initialized'))
			{
				// console.log("jaaa");
				var poll = new Poll(polls[i]);
			}
		}
	};
	initializePolls();

})(window, document, jQuery);